const utils = require('frontend-controller/lib/utils')
const ClientError = require('frontend-controller/client/error')

module.exports = {
	extends: [
		'/',
		'templates',
		'core',
		'table',
		'table'
	],

	config: {
		isSortable: true,
		supportLazyloading: true,
		buttonContext: 'documents',
		renderEmptyBeforReady: false,
		showHead: true,
		showInsertButton: false,
		showColorCodedRows: true,
		showAllBorders: true,
		showDelimiterBorders: true,
		inline: true,
		preventSortOfField: {
			customerName: true,
			shippingOrderCreatedByEmployeeID: true,
			shippingOrderIsSigned: true,
			sentToEmail: true,
		},
		// maxNrOfExportElements: 500000,
		// privilegeBase: 'nl_mailings',
		rowActionsProperties: {
			colWidth: '80px',
		// 	colSpan: 1,
		// 	rowSpan: 2
		},
		// customColActionsFile: 'templates/newsletter/mailings/table/customColActions',

		// // rowActions: {
		// // 	delete: true,
		// // 	edit: true,
		// // 	customs: [{
		// // 		buttonType: 'showDuplicate',
		// // 		buttonContext: 'mailing'
		// // 	}]
		// // },
		rowActions: {
			customs: [
				{
					buttonType: 'showReplace',
					buttonContext: 'shippingOrders',
					icon: 'fi fi-shippingOrder-showReplace',
					inline: true,
					privilegeCode: 'bo_shippingOrders:create',
				},
				{
					buttonType: 'showEdit',
					mode: 'invoice',
					icon: 'fi fi-euro',
					inline: true,
					neutral: true,
					privilegeCode: 'bo_invoices:read',
				},
			]
		},
		addRowClassViaAttribute: [
			{
				fieldCode:  'shippingOrderIsReplaceable',
				value:      true,
				class:      'isReplaceable',
			},
			{
				fieldCode:  'shippingOrderIsCanceled',
				value:      true,
				class:      'isCanceled',
			},
			{
				fieldCode:  'invoiceIsCanceled',
				value:      true,
				class:      'invoiceIsCanceled',
			},
			{
				fieldCode:  'invoiceHasNumber',
				value:      true,
				class:      'invoiceHasNumber',
			},
		],

		// autoInsertWhenEmpty: false, // if one opens up this table and there are no data to be shown, then this is an employee trying to create a shippingOrder.
		heartbeatRefreshOn: {
			'reconnect': true,
			// 'resourceChanged.all': true,
			// 'resourceChanged.bo_projects': true,
			// // 'resourceChanged.bo_customers': true,
			// // 'resourceChanged.bo_employees': true,
			// 'resourceChanged.bo_projectTerms': true,
			// 'resourceChanged.bo_projectTermJobs': true,
			// 'resourceChanged.bo_projectTermJobStatus': true,
			// // 'resourceChanged.bo_customerContacts': true,

			'resourceChanged.bo_shippingOrders': true,
			'resourceChanged.bo_invoices': true,
			// 'resourceChanged.bo_offers': true,

			'resourceChanged.bo_customers': true,
		},
	},

	model: {
		// projectID: null, // actual projectID
		// projectTermID: null, // actual projectTermID
	},

	methods: {

		// sanitizeResourceFilters: function(storage, resourceFilters, actionKey, areBaseTableResourceFilters){
		// 	resourceFilters = resourceFilters || {}
		// 	const resourceRegister = this.getResourceRegisterContent('shippingOrdersTable') || {}
		// 	const parentResourceFilters = resourceRegister.resourceFilters || {}
		//
		// 	this.model.projectID = parentResourceFilters.projectID
		// 	// this.model.projectTermID = parentResourceFilters.projectTermID
		//
		// 	utils.refReplace(resourceFilters, parentResourceFilters)
		// },

		showInsert(buttonContext, buttonMode){
			let result

			// TODO: IMPL
			if(buttonContext === 'shippingOrders'){
				// this.closest('templates_crew_projects_viewer', viewer => {
				// 	result = viewer.showEdit('timeRecordings', 'shippingOrder', this.model.projectID, this.model.projectTermID, undefined, undefined, 'shippingOrderTable', true)
				// 		.then(() => {
				// 			this.refreshData(true)
				// 		})
				// 		// .fail(() => {
				// 		// 	console.log('SHIPPING ORDER TABLE ABORT')
				// 		// })
				// })
			}

			return result || utils.promise.resolve()
		},

		async showEdit(rowID, rowData, buttonMode){
			if (rowID) {
				if(buttonMode === 'invoice'){
					const attributes 		= (rowData || {}).attributes || {}
                    const shippingOrderID 	= attributes.shippingOrderID
					let invoiceID           = attributes.invoiceID
					let editDeniedReason

					if(!invoiceID){
						const actionContext = await this.performAction(
							this.prepareAction('getInvoiceByShippingOrder', undefined, undefined, {
								source: {
									load: {
										resourceFilters: {
											shippingOrderID,
										}
									}
								}
							})
						)

						const attributes = ((((actionContext || {}).action || {}).response || {}).data || {}).attributes || {}
						const invoiceIDs = attributes.invoiceIDs || {}
						const editDeniedReasonsByShippingOrderID = attributes.editDeniedReasonsByShippingOrderID || {}
						if(invoiceIDs[shippingOrderID]){
							invoiceID = invoiceIDs[shippingOrderID]
						}
						if(editDeniedReasonsByShippingOrderID[shippingOrderID]){
							editDeniedReason = editDeniedReasonsByShippingOrderID[shippingOrderID]
						} else if(!invoiceID) {
							editDeniedReason = 'missingShippingOrder'
						}
					}

					let documentController
					this.closest('templates_core_controller_controller', c => documentController = c)

					if(!documentController){
						// TODO: global error handling?!? throw to have stacktrace, log to server, translate error, ...
						return this.showError(new ClientError('FEC_CLIENT_STRUCTURAL_INCONSISTENCY'))
					}

					if(!invoiceID && !editDeniedReason){
						editDeniedReason = 'missingInvoice'
					}

					if(editDeniedReason){
						return this.performAction(
							this.prepareAction('message', undefined, {
								messageDisplay: {
									message: `table.documents.invoices.getOrCreate.editDeniedReason.${editDeniedReason}`,
								},
							})
						)
					}

					await documentController.performAndStoreAction(
						'showEdit_invoice_inEffect',
						this.prepareAction('showEdit_invoice', undefined, {
							parentEntity: {
								entityID: invoiceID,
								primaryKey: 'invoiceID',
							},
							parentEntityForProperties: {
								resourceID: invoiceID,
							},
							parentEntityForTable: {
								baseFilters: {
									invoiceID
								}
							},
						}),
						true
					)
				} else if(rowData.attributes.shippingOrderUrl){
					window.open(rowData.attributes.shippingOrderUrl)
				}
			}
		},

		async showReplace(rowID, rowData){
			let result 			= utils.promise.resolve()
			const isReplaceable = !!((rowData || {}).attributes || {}).shippingOrderIsReplaceable
			const projectID 	= ((rowData || {}).attributes || {}).projectID
			const replaceShippingOrderID 	= ((rowData || {}).attributes || {}).shippingOrderID
			const baseActionKey = 'showEdit_timeRecordings'
			const buttonMode = 'shippingOrder'

			if(replaceShippingOrderID && projectID){
				// prevent shippingOrder replacement after it has been already billed or replaced
				if(!isReplaceable){
					await this.performAction(this.prepareAction('message', undefined, {
						messageDisplay: {
							message: 'error:shippingOrder.notAbleToReplaceShippingOrder'
						}
					}))
					return result
				}

				// ensure that the user knows what he / she is doing
				const decisionContext = await this.performDecision(
					'confirm',
					{
						component:  this,
						title:      storage.__('projects.crewViewer.replaceShippingOrderHint.title'),
						message:    storage.__('projects.crewViewer.replaceShippingOrderHint.message'),
					}
				) || {}
				const decision = decisionContext.decision || {}
				if(decision.type !== 'yes'){
					return result
				}

				result = this.performAndStoreAction(
					`${baseActionKey}_inEffect`,
					this.prepareAction(
						baseActionKey,
						undefined,
						{
							timeRecordingsTable: {
								resourceFilters: {
									projectID,
									type: buttonMode,
									replaceShippingOrderID,
								},
								buttonParams: {
									baseContext: 'timeRecordings',
									buttonContext: 'shippingOrders',
									buttonMode,
									projectID,
									origin: 'shippingOrderTable',
									returnOnUserDecisionPromise: false,
									additionalOptions: {
										replaceShippingOrderID,
									},
								}
							}
						},
						{
							source: {
								load: {
									componentData: {
										model: {
											titleKey: `modal.${baseActionKey}.titles.${buttonMode}`,
											buttons: {
												submit: {
													mode: buttonMode,
												}
											}
										}
									}
								}
							}
						}
					),
					true
				)
					.then(() => {
						this.refreshData(true)
					})
					// TODO: IMPL
					// .fail(() => {
					// 	console.log('SHIPPING ORDER TABLE ABORT')
					// })
			}

			return result
		},

		// patch data according to the given parameters
		async edit_timeRecordings(buttonParams, projectTerms, projectTermJobs){
			// TODO: what if no projectID is given?
			const projectID = buttonParams.projectID
			const replaceShippingOrderID = (buttonParams.additionalOptions || {}).replaceShippingOrderID

			// prepare projectTermJob updates
			const projectTermJobData = []
			for(const job of Object.values(projectTermJobs || {})){
				const attributes = job.attributes || {}
				const _primaryKey = attributes[job.primaryKey || '_NO_PK_FOUND']

				if(_primaryKey){
					projectTermJobData.push({
						primaryKey: job.primaryKey,
						attributes: {
							[job.primaryKey]:   _primaryKey,
							jobID:              attributes.jobID || undefined,
							startTS:            attributes.startTS,
							endTS:              attributes.endTS,
							duration:           attributes.duration,
						}
					})
				}
			}

			if(projectTermJobData.length > 0){
				await this.performAction(
					this.prepareAction(`edit_timeRecordings_${buttonParams.buttonMode}`, undefined, undefined, {
						source: {
							submit: {
								data: {
									resourceParams: {
										projectID,
										replaceShippingOrderID,
										projectTermJobs: projectTermJobData
									}
								}
							}
						}
					})
				)
			}

			return utils.promise.resolve()
		},

		onHeartbeat(message, heartbeatPrewarmedResourceHashes){
			const refreshers = this.config.heartbeatRefreshOn || {}
			const key = message.heartbeatKey
			const projectID = ((this.model.parentEntityForTable || {}).baseFilters || {}).projectID

			if(refreshers[key] && (
				(key === 'resourceChanged.bo_customers') ||
				(
					(
						key !== 'resourceChanged.bo_shippingOrders' &&
						key !== 'resourceChanged.bo_invoices'
					) || (!projectID || message.data.projectID == projectID || (message.data.projectIDs || {})[projectID])
				)
			)){
				this.refreshData(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes })
			}
		},
	},

	hooks: {

		async onDecision($element, options){
			const statusController = getComponent('statusController')
			let hideModal = true

			if(options.decisionComponent.hasClass('base_modal_modal')) {
				const modalContentComponent = options.decisionComponent.actions.loadContent.source.load.component

				switch(options.decisionType){
					case 'submit':
						if(modalContentComponent.hasClass('templates_crew_timeRecordings_propertiesForm_propertiesForm')){
							let timeTable
							modalContentComponent.find('templates_crew_timeRecordings_table_table', timeTableComponent => (timeTable = timeTableComponent))

							// update projectTerms and projectTermJobs
							const buttonParams              = timeTable.model.buttonParams || {}
							const updateProjectTermsData    = utils.simpleCopy(timeTable.model.projectTermFields || {})
							const updateProjectTermJobsData = utils.simpleCopy(timeTable.resourceData.data)
							const replaceShippingOrderID    = (buttonParams.additionalOptions || {}).replaceShippingOrderID
							if(statusController) {
								statusController.showStatus('status.progress.save')
							}
							await this.edit_timeRecordings(buttonParams, updateProjectTermsData, updateProjectTermJobsData)
							if(statusController){
								statusController.removeStatus()
								statusController.addPanel('status.done.save')
							}
							if(this.model.userDecisionPromise){
								this.model.userDecisionPromise.resolve()
								delete this.model.userDecisionPromise
							}

							// showEdit shipping orders if necessary
							if(buttonParams.baseContext === 'timeRecordings' && buttonParams.buttonMode === 'shippingOrder'){
								hideModal = false
								options.decisionComponent.hide()

								await this.performAction(
									this.prepareAction('edit_timeRecordings_createShippingOrder', undefined, undefined, {
										source: {
											submit: {
												data: {
													resourceParams: {
														projectID: buttonParams.projectID,
														replaceShippingOrderID,
													}
												}
											}
										}
									})
								)
							}

						}

						// hide modal
						if(hideModal){
							options.decisionComponent.hide()
						}
						break;

					case 'cancel':
					default:
						if(modalContentComponent.hasClass('templates_crew_timeRecordings_propertiesForm_propertiesForm')){
							if(statusController) statusController.removeStatus();
						}

						// hide modal
						if(hideModal){
							options.decisionComponent.hide()
						}
						break;
				}

				if(this.model.userDecisionPromise){
					this.model.userDecisionPromise.resolve()
					delete this.model.userDecisionPromise
				}
			}
		},
	},
}
